import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/[slug]/error.jsx");
